// #139 Next Day Openings Dashboard — gate predicate for the "openings"
// dashboard button alongside Help and Time Machine.
//
// Returns true ONLY when the user is logged in AND their Users document's
// `screenAccessList` contains the `"dashboard"` token.
//
// Access source (#202): managed in ONE place — the "Tab Access" section of
// UserDetailModal, which reads/writes `Users.screenAccessList` (the same array
// that gates the Optimizer/Scheduler/Jobs tabs). This replaced the legacy
// standalone boolean `Users.dashboardAccess`; a one-time backfill
// (dbtools/src/mutations/access-flags-to-screenaccesslist.mjs) seeded
// `"dashboard"` into screenAccessList wherever `dashboardAccess === true`. The
// legacy boolean is now dead data.
//
// Why `"dashboard"` (generic) and not `"nextDayOpenings"`: the gate is intended
// to cover ALL future dashboard variants (capacity overviews, late-jobs
// reports, etc.), not just the #139 next-day-openings view.
//
// Why `.includes(token)` (strict membership): the token is either present or it
// isn't — no truthiness coercion — so a future schema change can't accidentally
// open the gate.

export function canAccessDashboard(mongoUser, tsUserDocument) {
  return (
    Boolean(mongoUser) &&
    Array.isArray(tsUserDocument?.screenAccessList) &&
    tsUserDocument.screenAccessList.includes("dashboard")
  );
}
